import 'styles/app.scss';
import { customLayout, wpProvider } from './wrapPage';

export const wrapPageElement = ({ element, props }) =>
  customLayout(element, props);

export const wrapRootElement = ({ element }) => wpProvider(element);
